import React from 'react';
import styled from 'styled-components';

export const Nav = styled.nav`
display: flex;
justify-content: space-between;
margin-top: 1em;
font-size: 1.2em;
`

export const Soundwave = styled.div`
display: flex;
justify-content: left;
align-items: center;
margin-left: 12em;
gap: 1em;
text-decoration: none;
`
export const Disc = styled.div`
display: flex;
justify-content: flex-end;
align-items: center;
margin-right: 12em;
gap: 1em;
`

export const Logo = styled.img`
width: 3em;
`
